import { render, staticRenderFns } from "./penalty&points.vue?vue&type=template&id=6cad932d&scoped=true&"
import script from "./penalty&points.vue?vue&type=script&lang=js&"
export * from "./penalty&points.vue?vue&type=script&lang=js&"
import style0 from "./penalty&points.vue?vue&type=style&index=0&id=6cad932d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad932d",
  null
  
)

export default component.exports